import { useInfiniteQuery } from "@tanstack/react-query";
import axios from "axios";
import React from "react";
import { Link } from "react-router-dom";

const fetchGames = async ({ pageParam = 1 }) => {
  const { data } = await axios.get(
    `https://be-staging.obigin.com/content/games?type=downloadable&page=${pageParam}`
  );
  return {
    games: data.data.data,
    nextPage: data.data.nextPage || null,
  };
};

function UpcomingGames() {
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isError,
    isFetchingNextPage,
  } = useInfiniteQuery({
    queryKey: ["games"],
    queryFn: fetchGames,
    getNextPageParam: (lastPage) => lastPage.nextPage,
  });

  if (isLoading) return <p>Loading games...</p>;
  if (isError) return <p>Failed to load games</p>;

  const allGames = data.pages.flatMap((page) => page.games);

  return (
    <section className="upcoming-games-area upcoming-games-bg pt-60 pb-40">
      <div className="container">
        <div className="row">
          {allGames.map((game) => (
            <div
              className="col-lg-4 col-md-6 mb-4"
              key={game._id}
              style={{ display: "flex" }}
            >
              <Link to={`/details/${game._id}`} style={{ width: "100%" }}>
                <div
                  className="upcoming-game-item"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <div className="upcoming-game-head">
                    <div className="uc-game-head-title">
                      <h1
                        style={{
                          height: "50px",
                          overflow: "hidden",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          lineHeight: "1.2",
                        }}
                        className="text-red"
                      >
                        {game.name}
                      </h1>
                       <h4>
                        <a
                          href={game.link || "#"}
                          target="_blank"
                          rel="noreferrer"
                        >
                        {game.genre?.length > 0 ? game.genre.join(", ") : "N/A"}
                        </a>
                      </h4>
                    </div>
                  </div>
                  <p
                      style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {game.shortDescription || "No description available."}
                  </p>
                  <div
                    className="upcoming-game-thumb"
                    style={{ marginTop: "auto" }}
                  >
                    <img
                      src={
                        game.graphic || "assets/img/images/default_thumb.jpg"
                      }
                      alt={game.name}
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "cover",
                      }}
                    />
                    <div className="upcoming-game-cart">
                      <a
                        href={game.link || "#"}
                        className="btn transparent-btn"
                      >
                        <i className="fas fa-shopping-basket" />
                        {game.status === "live"
                          ? "View Details"
                          : "COMING SOON"}
                      </a>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>

        {/* Load More Button */}
        {hasNextPage && (
          <div className="text-center mt-4">
            <button
              className="btn btn-style-two"
              onClick={() => fetchNextPage()}
              disabled={isFetchingNextPage}
            >
              {isFetchingNextPage ? "Loading..." : "Load More"}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}

export default UpcomingGames;
